export default {
  // ========== Campos del formulario ==========
  fullName: 'Nombre y Apellido',
  email: 'Email',
  position: 'Cargo',
  institution: 'Institución',
  country: 'País',
  phone: 'Teléfono',
  message: 'Mensaje',

  // ========== Botones ==========
  send: 'Enviar',

  // ========== Títulos y mensajes ==========
  contactUsTitle: '¡Contáctanos!',
  contactDescription: 'Si está buscando una solución integral para el diseño curricular y el seguimiento de los resultados de aprendizaje, Key Learning es la solución: articula de forma automática e inteligente el currículo y la evaluación, generando información clave para orientar la toma de decisiones y contribuir a la mejora continua de la calidad educativa.',
  messageSent: '¡¡¡Mensaje enviado!!!',

  // ========== Banner de contacto ==========
  companyName: 'Key Learning SPA',
  address: 'Cerro El Plomo',
  addressDetail: '#5931, Oficina N°510, Las Condes, Santiago.',
  copyright: 'Copyright © KEY LEARNING SPA {year}. Todos los derechos reservados.',

  // ========== reCAPTCHA ==========
  recaptchaAttribution: 'Este sitio está protegido por reCAPTCHA y se aplican la',
  recaptchaPrivacyPolicy: 'Política de Privacidad',
  recaptchaAnd: 'y los',
  recaptchaTermsOfService: 'Términos de Servicio',
  recaptchaApply: 'de Google.',
}
